import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../../common/breadcrumbs";
import * as faqServices from "../../../services/faq.services";
import { SWAL_SETTINGS } from "../../../../../utils/Constants";
import { globalLoader, handleServerValidations } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";

const FAQEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();

  const [initialValues, setInitialValues] = useState({
    title: "",
    description: "",
    meta_tags: "",
    type: "",
  });
  const [dataLoaded, setDataLoaded] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const breadcrumbs = [
    { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard" },
    { title: t("admin.faq.link_faq"), url: "/admin/faq/list/1" },
    { title: t("admin.faq.link_edit"), url: "" },
  ];

  useEffect(() => {
    faqServices
      .Details(id)
      .then((res) => {
        const data = res?.data || {};
        setInitialValues({
          title: data.title || "",
          description: data.description || "",
          meta_tags: data.meta_tags || "",
          type: data.type || "",
        });
        setDataLoaded(true);
      })
      .catch((error) => {
        console.log("Fetch error: ", error);
      });
  }, [id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded && (
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validateOnBlur={false}
          validate={(values) => {
            const error = {};
            if (!values.title || !values.title.trim()) {
              error.title = "admin.faq.label_title_error";
            } else if (values.title.length > 100) {
              error.title = "Title must be less than or equal to 100 characters";
            }
            if (!values.description || !values.description.trim()) error.description = "admin.faq.label_description_error";
            if (!values.type) error.type = "Type is required";
            return error;
          }}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitted(true);
            globalLoader(true);
            let formData = new FormData();
            formData.append("o_id", id);
            formData.append("title", values.title.trim());
            formData.append("description", values.description.trim());
            formData.append("type", values.type);

            faqServices
              .Edit(formData)
              .then((response) => {
                setSubmitting(false);
                if (response.success) {
                  Swal.fire({
                    icon: "success",
                    text: response.message,
                    ...SWAL_SETTINGS,
                  });
                  setTimeout(() => {
                    globalLoader(false);
                    navigate(`/admin/faq/list/1`);
                  }, 1000);
                } else {
                  Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                  });
                  setSubmitted(false);
                  globalLoader(false);
                }
              })
              .catch((error) => {
                console.log("Submit error: ", error);
              });
          }}>
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched }) => (
            <form onSubmit={handleSubmit}>
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      <div>
                        <h6 className="main-content-label mb-3">{t("admin.faq.edit_faq")}</h6>
                      </div>
                      <div className="row row-sm">
                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="title" className="text-left d-flex">
                            {t("admin.faq.list_heading_title")}:<span className="requirestar">*</span>
                          </label>
                          <input name="title" id="title" type="text" onChange={handleChange} onBlur={handleBlur} value={values.title} className="form-control" placeholder={t("admin.faq.faq_title_placeholder")} />
                          <span className="text-danger d-flex text-left">{errors.title && touched.title && t(errors.title)}</span>
                        </div>

                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="type" className="text-left d-flex">
                            Type:<span className="requirestar">*</span>
                          </label>
                          <div className=" select-down-arrow">
                            <select
                              className="form-control"
                              name="type"
                              id="type"
                              onChange={(e) => {
                                setFieldValue("type", e.target.value);
                                setFieldTouched("type", true);
                              }}
                              onBlur={handleBlur}
                              value={values.type}>
                              <option value="" disabled>
                                Select Type
                              </option>
                              <option value="Business">Business</option>
                              <option value="User">User</option>
                            </select>
                          </div>
                          <span className="text-danger d-flex text-left">{errors.type && touched.type && t(errors.type)}</span>
                        </div>

                        <div className="col-lg-12 text-center form-group">
                          <label htmlFor="description" className="text-left d-flex">
                            {t("admin.faq.label_description")}:<span className="requirestar">*</span>
                          </label>
                          <textarea id="description" name="description" className="form-control" rows="5" value={values.description} onChange={handleChange} onBlur={handleBlur} />
                          <span className="text-danger d-flex text-left">{errors.description && touched.description && t(errors.description)}</span>
                        </div>

                        <div className="">
                          <button className="btn btn-main-primary signbtn mr-2" type="submit" disabled={submitted}>
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("Update")}
                          </button>
                          <button className="btn ripple btn-secondary" type="button" disabled={submitted} onClick={() => navigate(-1)}>
                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                            {t("Cancel")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      )}
    </>
  );
};

export default FAQEdit;
